import _get from "lodash-es/get";

import getAxios from "../../utils/axios";
import APIendpoints from "../../utils/constants/APIendpoints";
import actionTypes from "../actionTypes";

function deleteCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function signIn(requestData) {
  return (dispatch) => {
    dispatch({ type: actionTypes.AUTH_SIGN_IN_BEGIN });
    getAxios()
      .post(APIendpoints.signIn, requestData)
      .then(({ data, headers }) => {
        // set in localStorage
        const token = headers.authorization;
        window.localStorage.setItem("token", token);

        dispatch({
          type: actionTypes.AUTH_SIGN_IN_DONE,
          signInResponse: data,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.AUTH_SIGN_IN_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function signOut() {
  return (dispatch) => {
    dispatch({ type: actionTypes.AUTH_SIGN_OUT_BEGIN });
    getAxios(true)
      .post(APIendpoints.signOut)
      .then(() => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("outletId");
        deleteCookie("token")
        deleteCookie("outletId")
        window.location.href = "/";
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.AUTH_SIGN_OUT_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });

        window.localStorage.removeItem("token");
        window.localStorage.removeItem("outletId");
        deleteCookie("token")
        deleteCookie("outletId")
        window.location.href = "/";
      });
  };
}

function signOutAndRouted(routeTo) {
  return dispatch => {
    dispatch({ type: actionTypes.AUTH_SIGN_OUT_BEGIN });
    getAxios(true)
      .post(APIendpoints.signOut)
      .then(() => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("outletId");
        if (routeTo) {
          window.location.href = routeTo;
        } else {
          window.location.reload();
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.AUTH_SIGN_OUT_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          )
        });
      });
  };
}

// Self-Onboardiong step 1

function registerStepOne(params) {
  return (dispatch) => {
    dispatch({ type: actionTypes.REGISTER_STEP_ONE_BEGIN });
    getAxios()
      .post(APIendpoints.registerStepOne, params)
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.REGISTER_STEP_ONE_DONE,
          salesLeadId: data.response.salesLeadId,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REGISTER_STEP_ONE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function updateRegStepOne(params, salesLeadId) {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_REG_STEP_ONE_BEGIN });
    getAxios()
      .put(APIendpoints.updateRegStepOne(salesLeadId), params)
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.UPDATE_REG_STEP_ONE_DONE,
          salesLeadId: data.response.salesLeadId,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.UPDATE_REG_STEP_ONE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function registerStepTwo(params) {
  return (dispatch) => {
    dispatch({ type: actionTypes.REGISTER_STEP_TWO_BEGIN });
    getAxios()
      .post(APIendpoints.registerStepTwo, params)
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.REGISTER_STEP_TWO_DONE,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REGISTER_STEP_TWO_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function setRegisterData(stepNo, data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_REGISTER_DATA_BEGIN,
      stepNo: stepNo,
      data: data,
    });
  };
}

function uploadImageOnboard(type, params, storedData) {
  return (dispatch) => {
    if (type === "Pan") {
      dispatch({ type: actionTypes.UPLOAD_PAN_IMAGE_BEGIN });
    } else if (type === "FSSAICertificate") {
      dispatch({ type: actionTypes.UPLOAD_FSSAI_IMAGE_BEGIN });
    } else if (type === "GstCertificate") {
      dispatch({ type: actionTypes.UPLOAD_GST_IMAGE_BEGIN });
    }
    getAxios()
      .post(APIendpoints.uploadOnboardDocument, params)
      .then(({ data, headers }) => {
        if (type === "Pan") {
          dispatch({
            type: actionTypes.UPLOAD_PAN_IMAGE_DONE,
            data: data.response.image[0],
          });
        } else if (type === "FSSAICertificate") {
          dispatch({
            type: actionTypes.UPLOAD_FSSAI_IMAGE_DONE,
            data: data.response.image[0],
          });
        } else if (type === "GstCertificate") {
          dispatch({
            type: actionTypes.UPLOAD_GST_IMAGE_DONE,
            data: data.response.image[0],
          });
        }
      })
      .catch((err) => {
        if (type === "Pan") {
          dispatch({
            type: actionTypes.UPLOAD_PAN_IMAGE_FAIL,
            error: _get(
              err,
              ["response", "data", "error", "message"],
              "Something went wrong!"
            ),
          });
        } else if (type === "FSSAICertificate") {
          dispatch({
            type: actionTypes.UPLOAD_FSSAI_IMAGE_FAIL,
            error: _get(
              err,
              ["response", "data", "error", "message"],
              "Something went wrong!"
            ),
          });
        } else if (type === "GstCertificate") {
          dispatch({
            type: actionTypes.UPLOAD_GST_IMAGE_FAIL,
            error: _get(
              err,
              ["response", "data", "error", "message"],
              "Something went wrong!"
            ),
          });
        }
      });
  };
}

function validateGstNumber(gst) {
  return (dispatch) => {
    dispatch({ type: actionTypes.VALIDATE_GST_BEGIN });
    getAxios()
      .get(APIendpoints.checkGst(gst))
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.VALIDATE_GST_DONE, data: data });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.VALIDATE_GST_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function checkValidPhoneNumber(requestData) {
  return (dispatch) => {
    dispatch({ type: actionTypes.VALIDATE_PHONE_NUMBER_BEGIN });
    getAxios()
      .post(APIendpoints.validatePhoneNumber, requestData)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.VALIDATE_PHONE_NUMBER_DONE });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.VALIDATE_PHONE_NUMBER_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function registerVerifyOtp(otp, phoneNumber) {
  let requestData = {
    OtpNumber: otp,
    PhoneNumber: phoneNumber,
  };
  return (dispatch) => {
    dispatch({ type: actionTypes.REGISTER_VERIFY_OTP_BEGIN });
    getAxios()
      .post(APIendpoints.registerVerifyOtp, requestData)
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.REGISTER_VERIFY_OTP_DONE });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REGISTER_VERIFY_OTP_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function getOtp(phoneNumber) {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_OTP_BEGIN });
    getAxios()
      .post(APIendpoints.getOtp(phoneNumber))
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.GET_OTP_DONE });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_OTP_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function registerAllSteps(params) {
  return (dispatch) => {
    dispatch({ type: actionTypes.REGISTER_ALL_STEPS_BEGIN });
    getAxios()
      .post(APIendpoints.registerAllSteps, params)
      .then(({ data, headers }) => {
        const token = headers.authorization;
        window.localStorage.setItem("token", token);
        dispatch({
          type: actionTypes.AUTH_SIGN_IN_DONE
        })
        dispatch({
          type: actionTypes.REGISTER_ALL_STEPS_DONE,
          promotionData: data.response.promotion,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REGISTER_ALL_STEPS_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function forgotPasswordEnterPhone(phoneNumber) {
  return (dispatch) => {
    dispatch({ type: actionTypes.FORGOT_PASSWORD_ENTER_PHONE_BEGIN });
    getAxios()
      .post(APIendpoints.forgotPasswordEnterPhone(phoneNumber), {
        isForgotPassword: true,
        userPhoneNumber: phoneNumber,
      })
      .then(({ data, headers }) => {
        dispatch({ type: actionTypes.FORGOT_PASSWORD_ENTER_PHONE_DONE });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.FORGOT_PASSWORD_ENTER_PHONE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function validateReferralCode(code) {
  return (dispatch) => {
    dispatch({ type: actionTypes.VALIDATE_REFERRAL_CODE_BEGIN });
    getAxios()
      .get(APIendpoints.referralCode(code))
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.VALIDATE_REFERRAL_CODE_DONE,
          referralCode: data.response.referralDetails,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.VALIDATE_REFERRAL_CODE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function promotionVisibility(cityId = 0) {
  return (dispatch) => {
    dispatch({ type: actionTypes.PROMOTION_VISIBILITY_BEGIN });
    getAxios()
      .get(APIendpoints.getBonus("signup", cityId))
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.PROMOTION_VISIBILITY_DONE,
          bonusAmount: data.response.signup_bonus_amount,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.PROMOTION_VISIBILITY_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function setReferralCode(code) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_REFERRAL_CODE_DONE, code });
  };
}

function validatePinCode(cityId, pinCode) {
  return (dispatch) => {
    dispatch({ type: actionTypes.VALIDATE_PINCODE_BEGIN });
    getAxios()
      .get(APIendpoints.validatePinCode(cityId, pinCode))
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.VALIDATE_PINCODE_DONE,
          isPinCodeValid: data.response,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.VALIDATE_PINCODE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function serviceablePinCode(cityId, pinCode) {
  return (dispatch) => {
    dispatch({ type: actionTypes.VALIDATE_PINCODE_BEGIN });
    getAxios()
      .get(APIendpoints.serviceablePinCode(cityId, pinCode))
      .then(({ data, headers }) => {
        dispatch({
          type: actionTypes.VALIDATE_PINCODE_DONE,
          serviceablePinCode: data.response,
          isPinCodeValid: data.response.IsServiceable !== "NOT_SERVICEABLE"
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.VALIDATE_PINCODE_FAIL,
          error: _get(
            err,
            ["response", "data", "error", "message"],
            "Something went wrong!"
          ),
        });
      });
  };
}

function resetOnboardThirdFailStatus() {
  return (dispatch) => {
    dispatch({ type: actionTypes.REGISTER_ALL_STEPS_INIT });
  };
}

export {
  signIn,
  signOut,
  registerStepOne,
  setRegisterData,
  uploadImageOnboard,
  validateGstNumber,
  checkValidPhoneNumber,
  registerVerifyOtp,
  getOtp,
  registerAllSteps,
  forgotPasswordEnterPhone,
  validateReferralCode,
  setReferralCode,
  promotionVisibility,
  registerStepTwo,
  updateRegStepOne,
  validatePinCode,
  resetOnboardThirdFailStatus,
  signOutAndRouted,
  serviceablePinCode
};
